import { Component, computed, HostBinding, input, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { NgClass, NgTemplateOutlet } from '@angular/common';
import { PositionEnum } from '../../_enums/position.enum';
import { SdIconComponent } from '../icons/icon/icon.component';
import { SdConvertedPriceComponent } from '../converted-price/converted-price.component';

@Component({
  selector: 'sd-price',
  templateUrl: './price.component.html',
  standalone: true,
  imports: [NgClass, NgTemplateOutlet, SdIconComponent, TranslateModule, SdConvertedPriceComponent]
})
export class SdPriceComponent {
  isSmall = input<boolean>();
  price = input<string>();
  discountedPrice = input<string>();
  recommendedPrice = input<string>();
  isSmallRecommendedPrice = input<boolean>();
  isDiscountWithRecommendedPrice = input<boolean>();
  isBundle = input<boolean>();
  isSSR = input(true);
  class = input('');

  openRecommendedPriceModal = output<void>();

  @HostBinding('class.is-small')

  @HostBinding('class')
  get hostClasses(): string {
    return this.computedHostClasses();
  }

  PositionEnum = PositionEnum;

  computedHostClasses = computed(() => {
    return [this.class(), this.isSSR() ? 'is-hidden' : ''].filter(Boolean).join(' ');
  });

  onOpenRecommendedPriceModal() {
    this.openRecommendedPriceModal.emit();
  }
}
